import React from 'react'
import { Layout } from 'antd';
import NwHomeHeader from './NwHomeHeader';
import NwFooter from './NwFooter';

const NwHomeLayout = ({ children }) => {
  return (
    <Layout style={{minHeight:"100vh", height: '100%'}}>
      <NwHomeHeader />
      {children}
      <NwFooter />
    </Layout>
  )
}

export default NwHomeLayout

